// extracted by mini-css-extract-plugin
export default {"title":"tags-form_title__9rNFo","tableWrap":"tags-form_tableWrap__nZHZc","table":"tags-form_table__mGOvm"};